export default "__VITE_ASSET__DXsXLHWu__"